import QRCodeStand from "../../../Assets/QRCodeStand.png";
import TagNFC from "../../../Assets/TagNFC.jpeg";

/** Catalog for QR Code Kit shop (ids must match order line `itemId`). */
export const QR_CODE_KIT_SHOP_ITEMS = [
	{
		id: 1,
		name: "QR Code Scanner",
		detail: {
			heading: "This item includess",
			points: [
				"PVC Stand",
				"NFC attached to PVC Stand",
				"QR code and design printed on PVC stand",
			],
		},
		price: 30,
		image: QRCodeStand,
	},
	{
		id: 2,
		name: "NFC Tags",
		detail: {
			heading:
				"Elegant waterproof NFC table tags for effortless restaurant reviews.",
			points: [],
		},
		price: 15,
		image: TagNFC,
	},
];
